import React from "react";
import { Field } from "formik";

import styles from "./NameInput.module.scss";

import { FieldPropsType, NameInputPropsType } from "./types";

export const NameInput: React.FC<NameInputPropsType> = (props) => {
  const { name, focusThisInput = false, placeholder, lable } = props;

  const inputRef = React.useRef<HTMLInputElement>(null);

  React.useEffect(() => {
    if (focusThisInput) {
      inputRef.current?.focus();
    }
  }, []);

  return (
    <Field name={name}>
      {(fieldProps: FieldPropsType) => {
        const { field, meta } = fieldProps;

        return (
          <div className={styles.inputWrapper}>
            <label
              htmlFor={name}
              className={`
                ${styles.label}
                ${meta.touched && meta.error ? styles.error : null}
              `}>
              {lable}
            </label>
            <input
              ref={inputRef}
              type="text"
              id={name}
              placeholder={placeholder}
              className={`
                ${styles.input}
                ${meta.touched && meta.error ? styles.error : null}
              `}
              {...field}
            />
          </div>
        );
      }}
    </Field>
  );
};
